<template>
  <div class="shop-icons__wrapper py15">
    <div class="hidden-xs-and-tablet">
      <div class="flex">
        <div class="shop-icons flex" v-if="!isPrenumerata">
          <img v-lazy="'/assets/product-tabs/official_store.svg'" height="32" alt="Oficjalny sklep wydawnictwa Burda Media Polska">
          <span class="mx10">Oficjalny sklep wydawnictwa Burda Media Polska</span>
        </div>
        <div class="shop-icons flex" v-else>
          <img v-lazy="'/assets/product-tabs/dostawa.svg'" height="32" alt="Darmowa dostawa pod wskazany adres">
          <span class="mx10">Darmowa dostawa pod wskazany adres</span>
        </div>
        <div v-for="(item, idx) in shopIconsDesktop" class="shop-icons flex" :key="idx + 'shop-icons-desktop'">
          <img v-lazy="item.icon" :width="item.width" :height="item.height" :alt="$t(item.txt)">
          <span class="mx10">{{ $t(item.txt) }}</span>
        </div>
      </div>
    </div>
    <div class="visible-xs-and-tablet tablet-style">
      <div class="shop-icons flex" v-if="!isPrenumerata">
        <img v-lazy="'/assets/product-tabs/official_store.svg'" width="25" height="25" alt="Oficjalny sklep wydawnictwa Burda Media Polska">
        <span class="mx10">Oficjalny sklep wydawnictwa Burda Media Polska</span>
      </div>
      <div class="shop-icons flex" v-else>
        <img v-lazy="'/assets/product-tabs/dostawa.svg'" width="25" height="25" alt="Darmowa dostawa pod wskazany adres">
        <span class="mx10">Darmowa dostawa pod wskazany adres</span>
      </div>
      <div v-for="(item, idx) in shopIconsDesktop" class="shop-icons flex" :key="idx + 'shop-icons-mobile'">
        <img v-lazy="item.icon" width="25" height="25" :alt="$t(item.txt)">
        <span class="mx10">{{ $t(item.txt) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      shopIconsDesktop: [
        {
          icon: '/assets/product-tabs/prezent.svg',
          txt: 'Attractive special offers',
          width: 32,
          height: 32
        },
        {
          icon: '/assets/product-tabs/speed.svg',
          txt: 'Always earlier than at the kiosk',
          width: 28,
          height: 32
        }
      ]
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPrenumerata () {
      if (this.product.type_id === 'subscription') {
        return true
      } else {
        return this.product.bundle_options && this.product.bundle_options.some(option =>
          option.product_links.some(link =>
            link.product && link.product.type_id === 'subscription'
          )
        )
      }
    }
  }
}
</script>
<style lang="scss">
.shop-icons__wrapper {
  display: flex;
  flex-direction: row;
  -ms-flex-direction: row;
}
.shop-icons {
  flex-direction: column;
  -ms-flex-direction: column;
  align-items: center;
  padding: 10px 0;
  span {
    font-size: 12px;
    text-align: center;
  }
  img {
    // height: 32px;
    fill: #FF8557;
  }
}
.tablet-style {
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    flex-direction: column;
    -ms-flex-direction: column;
  }
}
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
.shop-icons__wrapper {
  flex-direction: column;
  -ms-flex-direction: column;
  padding: 0 5px;
}
  .shop-icons {
    flex-direction: row;
    -ms-flex-direction: row;
    align-items: center;
    padding: 10px 0;
    height: 23px;
    span {
      font-size: 12px;
      text-align: left;
    }
    img {
      height: 25px;
      width: 25px;
    }
  }
  .shop-icon {
    font-size: 30px;
    margin: 5px;
    margin-right: 20px;
    border-radius: 50%;
  }
}

</style>
